import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
  variant?: 'gold' | 'outline';
  showArrow?: boolean;
}

/** Checkout oficial y único de KETO 4P. Todos los botones de compra apuntan acá. */
export const CHECKOUT_URL = 'https://keto-4p.impultienda.ar/checkout';
export function CTAButton({
  label = 'QUIERO MIS 500 RECETAS KETO',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = variant === 'outline' ? 'border border-gold/50 bg-transparent text-gold hover:bg-gold/10 focus-visible:ring-gold/40' : 'bg-gold text-ink shadow-[0_16px_44px_-14px_rgba(255,196,0,0.75)] hover:bg-gold-hot hover:shadow-[0_20px_54px_-14px_rgba(255,196,0,0.85)] focus-visible:ring-gold/50';
  return <a href={href} onClick={handleClick} className={`group inline-flex min-h-[60px] w-full items-center justify-center gap-2.5 rounded-xl px-6 py-4 text-center font-display text-[0.9rem] uppercase leading-tight tracking-[0.02em] transition-[transform,box-shadow,background-color] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 sm:w-auto sm:px-9 sm:text-[1.02rem] ${palette} ${className}`} data-id="element-48" data-mp="19apqimgh5ybj">
      {label}
      {showArrow && <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden strokeWidth={2.75} data-id="element-49" data-mp="1w7t0oqez39zi" />}
    </a>;
}